import React from 'react';
import { ReactComponent as IconCall } from '../../../Assets/Image/svg/Call2.svg';
import { ReactComponent as IconLocation } from '../../../Assets/Image/svg/Location2.svg';
import { useForm } from 'react-hook-form';
import Inputs from '../../share/input/Inputs';
import Textarea from '../../share/textarea/Textarea';
import { BtnPrimary } from '../../share/buttons/Btn';

function AboutUs() {
	const {
		register,
		handleSubmit,
		control,
		formState: { errors },
	} = useForm();

	const onSubmit = (data) => console.log(data);

	return (
		<div className='about'>
			<div className='container-primary pb-[5.9rem] pt-12'>
				<h2 className='text-md text-primary-dark font-bold mb-[3.5rem] text-center'>
					داستان ما چیست؟
				</h2>
				<div className='shadow-btn pt-[3.3rem] px-[2.8rem] pb-[3.3rem] rounded-[1.5rem] pagedescription mb-[5.9rem]'>
					<h3>بوت‌وب، پل ارتباطی شما و دنیای بی‌نهایت اطلاعات</h3>
					<p>
						بوت‌وب در حقیقت یک پل ارتباطی و یک زیرساخت مطمئن برای افراد
						علاقمند به شرکت در وبینارها در حوزه‌های مختلف و برگزارکنندگان
						این وبینارهاست. در بوت‌وب افراد نه تنها با علاقمندان به حوزه‌ی
						مورد علاقه‌شان آشنا می‌شوند، بلکه امکان تیم‌سازی و استفاده از
						تجربیات دیگر افراد نیز در این بستر به خوبی محیاست.
					</p>
					<h3>ویژگی های شاخص بوت‌وب</h3>
					<ul className='pagedescription__listlist'>
						<li>
							سادگی و زیبایی: طراحی بوت‌وب به گونه‌ای است که تمامی افراد
							در هر سنی بتوانند از آن استفاده کنند و در حقیقت عاری از هر
							گونه پیچیدگی کاذب است.
						</li>
						<li>
							به‌روز بودن: بستر و سرورهای مورد استفاده در بوت‌وب با دقت و
							تحقیق انتخاب شده‌اند تا عاری از هر گونه مشکل باشند.
						</li>
						<li>
							حمایت از مشتری: با وجود یک تیم پشتیبانی متخصص دیگر از بابت
							مشکلات احتمالی نگرانی نخواهید داشت.
						</li>
						<li>
							صرفه اقتصادی: در بوت‌وب سعی شده است تا قیمت‌گذاری به صورت
							رقابتی باشد تا هر فردی با هر سطحی از درآمد، توانایی
							بهره‌مندی از آن را داشته باشد.
						</li>
						<li>
							دقت و امنیت: یکی از مهم‌ترین فاکتورها در بوت‌کمپ‌های خصوصی
							امنیت آن‌هاست که با بوت‌وب به طور کامل تامین خواهد شد.
						</li>
						<li>
							راه‌کارهای تخصصی: با کمک تیم متخصص بوت‌وب، به راحتی
							می‌توانید بوت‌کمپ دلخواه خود را با تنظیمات و دسترسی موردنظر
							خود ایجاد کنید.
						</li>
					</ul>
				</div>
				<div className='grid grid-cols-2 shadow-btn rounded-[1.5rem] py-[4.6rem] pr-[9.8rem] pl-[7.9rem] gap-[6.5rem] about__form'>
					<div className='flex flex-col about__form--content'>
						<p className='text-[1.8rem] text-primary-dark heading-extra-loose text-justify mb-[8.3rem]'>
							سوالی دارید؟ نظر، انتقاد و یا پیشنهادی به ذهنتان رسیده است؟
							همین حالا و از طریق همین فرم اطلاعات خود را وارد کنید تا
							کارشناسان ما در اسرع وقت پاسخگوی سوال، انتقاد یا پیشنهاد
							شما باشند.
						</p>
						<div className='flex items-center mb-[1.9rem]'>
							<IconCall className='h-[1.8rem] text-light-prim1 ml-[.8rem] font-medium' />
							<span className='text-[1.4rem]'>۰۳۱-۴۷۸۳۰۰</span>
						</div>
						<div className='flex items-center mb-[1.9rem]'>
							<IconCall className='h-[1.8rem] text-light-prim1 ml-[.8rem] font-medium' />
							<span className='text-[1.4rem] font-medium'>
								۹۱۲۴۳۶۴۸۴۹۹
							</span>
						</div>
						<div className='flex items-center'>
							<IconLocation className='h-[2rem] ml-[.8rem]' />
							<span className='text-[1.4rem] text-light-prim1 font-medium'>
								تهران، کارگر شمالی، خیابان فرشی مقدم، ساختمان انتشارات
								دانشگاه تهران، طبقه همکف، دفتر مرکزی هاب شهر هوشمند
							</span>
						</div>
					</div>
					<div>
						<form onSubmit={handleSubmit(onSubmit)}>
							<Inputs
								register={{
									required: {
										value: true,
										message: 'نام را وارد کنید',
									},
								}}
								type='text'
								name='name'
								control={control}
								placeholder='نام'
								className='border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] active__input'
							/>
							<Inputs
								register={{
									required: {
										value: true,
										message: 'ایمیل را وارد کنید',
									},
								}}
								type='text'
								name='email'
								control={control}
								placeholder='ایمیل'
								className='border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] active__input'
							/>

							<Textarea
								className=' border-[.1rem] border-solid  border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem]  rounded-[1.5rem] mb-[1.6rem] min-h-[19.6rem] py-[2rem] px-[1.4rem] resize-none hover:border-purple-dark active__input'
								name='message'
								placeholder='متن پیام'
								register={{
									required: {
										value: true,
										message: 'متن را وارد کنید',
									},
								}}
								control={control}
							></Textarea>
							<BtnPrimary
								className='py-[1.3rem] px-[1.5rem] flex mr-auto'
								text='ارسال پیام'
							/>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
}
export default AboutUs;
